
import { defineComponent, ref, computed, watch, watchEffect } from "vue";
import ParticipantPage from "@/views/pages/ParticipantPage.vue";
import HosterPage from "@/views/pages/HosterPage.vue";
import ParticipantModal from "@/components/participant/modal/participantModal.vue"
import { useStore } from "vuex";
import { useRouter, useRoute } from 'vue-router';
import { ArrowForwardCircle, Create } from "@vicons/ionicons5";
import { Module as exposedModule,Actions as ExposedActions, Mutations as ExposedMutations, Getters as ExposedGetters } from "@/store/enums/exposedEnums";
import stc from "string-to-color";
import eventStatusModel from "@/core/models/share/status.interface";
import { useMessage, useDialog } from 'naive-ui'
export default defineComponent({
  name: "Home",
  components: {
    ParticipantPage,
    HosterPage,
    ArrowForwardCircle,
    Create,
    ParticipantModal
  },
  setup() {
    const switchFlag = ref(0);
    const weclomeFlag = ref(false);
    const store = useStore();
    const router = useRoute();
    const Router = useRouter();

    const showModal = ref(false);
    const modalEventId = ref<string>("");
    
    
    // const fpPromise = FingerprintJS.load() 
    //   fpPromise
    //   .then(fp => fp.get())
    //   .then(result => {
    //     // This is the visitor identifier:
    //     const visitorId = result.visitorId
    //     console.log("visitorId", visitorId)
    //     axios.defaults.headers.common['visitorId'] = visitorId;

        

    //     axios.interceptors.request.use(
    //       function(config) {
            
    //         if (visitorId) {
    //           config.headers["visitorId"] = visitorId;
    //         }
    //         return config;
    //       },
    //       function(error) {
    //         return Promise.reject(error);
    //       }
    //     );

        
          
    //   })


    const statusHeaders = computed<Array<eventStatusModel>>(
      () => store.getters[exposedModule.desc + ExposedGetters.EventStatuses]
    );
    const onOpenModal = (EventParticipantId: string) => {
      store.dispatch(`${exposedModule.desc}${ExposedActions.LoadExposed}`, { participatantId: EventParticipantId })
      showModal.value = true;
      modalEventId.value = EventParticipantId;
    }
    const state = localStorage.getItem('State');
    const EventParticipantId = localStorage.getItem('EventParticipantId');

    if (router.query.EventParticipantId != undefined && router.query.EventParticipantId != '') {
      onOpenModal(router.query.EventParticipantId.toString())
      localStorage.setItem('EventParticipantId', router.query.EventParticipantId.toString());
      localStorage.setItem('State', "Reply");
    }else if (state == "Reply" && EventParticipantId != undefined ){ 
      //onOpenModal(EventParticipantId)
    }

    //console.log(user);

    // const needReloadParticipantEventsFlag = computed<Array<boolean>>(
    //   () => store.getters[Module.desc + Getters.NeedReloadParticipantEventsFlag]
    // );

    // function onHost() {
    //   switchFlag.value = 0;
    //   weclomeFlag.value = true;
    // }
    // function onAttend() {
    //   switchFlag.value = 1;
    //   weclomeFlag.value = true;
    // }

    // store.dispatch(Module.desc + Actions.HandEventStatuses);
    // store.dispatch(Module.desc + Actions.HandUserResponseStatuses);

    

    // watch(
    //   () => store.getters[rootGetters.API_User],
    //   (nV: User, oV: User) => {
    //     if (nV.MemberId) {
    //       store.dispatch(Module.desc + Actions.HandMyHostingEvents);
    //       store.dispatch(Module.desc + Actions.HandMyParticipantEvents);
    //       store.dispatch(Module.desc + Actions.HandMyRecordEvents);
    //       //console.log('home', router.query);
    //       if (router.query.State == 'Reply' ) {
    //         onAttend()
    //       }


    //     }
    //   }
    // );

    // watch(
    //   () =>
    //     store.getters[Module.desc + Getters.NeedReloadParticipantEventsFlag],
    //   (nV: Boolean, oV: Boolean) => {
    //     if (nV) {
    //       store.dispatch(Module.desc + Actions.HandMyParticipantEvents);
    //       store.dispatch(Module.desc + Actions.HandMyRecordEvents);
    //       store.dispatch(
    //         Module.desc + Actions.UpdateReloadParticipantEventsFlag,
    //         false
    //       );
    //     }
    //   }
    // );

    // console.log('home', router.query);
    // if (router.query.state == 'reply' && user.value.MemberId) {
    //   onAttend()
    // }
    function stringColor(str: String, alpha: Boolean) {
      var colour = stc(str);
      return colour + (alpha ? "66" : "");
    }
    return {
      //switchFlag,
      // onHost,
      // onAttend,
      //weclomeFlag,
      // headerCounter
      // MyHostingEventNumber: computed<Number>(
      //   () => store.getters[Module.desc + Getters.MyHostingEventNumber]
      // ),
      // MyParticipantEventNumber: computed<Number>(
      //   () => store.getters[Module.desc + Getters.MyParticipantEventNumber]
      // ),

      showModal,
      modalEventId,
      stringColor,
      statusHeaders
    };
  },
});
